"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = eventReemitter;
// Creates an event handler that re-emits the event on `this`.
function eventReemitter(eventName) {
  var _this = this;
  return function (event) {
    _this.emit(eventName, event);
  };
}